<template>
  <div class="pa-3">
    <v-row class="mb-2">
      <v-col col="6"></v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-text-field
          v-model="searchText"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @keyup="searchGlobal()"
        ></v-text-field>
      </v-col>
    </v-row>
    <div :id="`archive-${batch.batchNo}`" v-for="(batch, bindex) in filteredItems" :key="bindex">
      <v-expansion-panels class="mb-5" v-model="batch.panel" multiple accordion>
        <v-expansion-panel expand> 
          <v-expansion-panel-header>
            <h3>{{batch.name}}</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-3 no-gutters">
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-col cols="12" sm="9" md="9" lg="9">
                  <v-btn 
                  color="success"
                  class="mb-2"
                  small
                  v-if="batch.selectedPayments.length > 0"
                  @click="restoreArchive(bindex)">
                    <v-icon small>mdi-restore</v-icon> Restore
                  </v-btn>
                </v-col>
                <v-col class="float-right" cols="12" sm="3" md="3" lg="3">
                  <v-text-field
                    v-model="batch.filter.search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    @keyup="changeSearch(batch.filter, batch.filter.search)" 
                  ></v-text-field>
                </v-col>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-data-table
                  :headers="headers"
                  :items="batch.displayData"
                  :items-per-page="10"
                  :search="batch.filter.workingSearch"
                  :no-data-text="'Empty list'"
                  class="table-small elevation-1"              
                  :key="dataTableKey"
                  show-select
                  :single-select="false"
                  v-model="batch.selectedPayments"
                  @toggle-select-all="selectAllItems"
                >
                  <template v-slot:[`item.data-table-select`]="{item}">
                    <v-checkbox
                      class="custom-checkbox"
                      v-model="batch.selectedPayments"
                      label=""
                      :value="item"
                      color="grey darken-2"
                    ></v-checkbox>
                  </template>
                  <template v-slot:[`item.instagram`]="{ item }">
                    <td class="text-left">
                      <social-handle
                        :isTikTok="item.isTikTok || item.tiktokOwner"
                        :isInstagram="!item.isTikTok && !item.tiktokOwner"
                        :tiktokHandle="item.instagram"
                        :instagramHandle="item.instagram"
                      />
                    </td>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <td class="text-xs-left" style="min-width:75px">
                      <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.amount | thousandSeprator}}
                    </td>
                  </template>
                  <template v-slot:[`item.paymentStatus`]="{ item }">
                    <td class="text-xs-left" style="min-width:50px">{{getPaymentStatus(item.paymentStatus)}}</td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
import userAPIs from '../User/userAPIs';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import { mapState, mapGetters } from 'vuex';
import utils from '../../../utils';
import config from '@/config';
import campaignConfig from '../Campaign/config'
export default {
  name: 'ArchiveList',
  components: {
    SocialHandle
  },
  data () {
    return {
      headers: [
        // {value: 'submissionDate', text: 'Submission Date', sortable: true},
        {value: 'liveDate', text: 'Live Date', sortable: true},
        {value: 'dueDate', text: 'Due Date', sortable: true},
        {value: 'swiftCode', text: 'Swift Code', sortable: true},
        {value: 'bankAccount', text: 'Bank A/C No.', sortable: true},
        {value: 'username', text: 'Payee Name', sortable: true},
        {value: 'country', text: 'Country', sortable: true},
        {value: 'bankName', text: 'Bank Name', sortable: true},
        {value: 'email', text: 'Email', sortable: true},
        {value: 'amount', text: 'Amount', sortable: true},
        {value: 'instagram', text: 'IG Handle/Tiktok Handle', sortable: true},
        {value: 'clientName', text: 'Client Name', sortable: true},
        {value: 'campaignName', text: 'Campaign Name', sortable: true},
        {value: 'IONumber', text: 'Campaign IO Number', sortable: true},
        {value: 'paymentDate', text: 'Payment Date (DD/MM/YYYY)', sortable: true},
        {value: 'paymentSubmissionDate', text: 'Submission Date (DD/MM/YYYY)', sortable: true},
        {value: 'paymentStatus', text: 'Payment Status', sortable: true},
        {value: 'bankReference', text: 'Bank Reference', sortable: true},
        {value: 'POCDisplay', text: 'POC', sortable: true},
        {value: 'agreedDeliverables', text: 'Agreed Deliverables', sortable: true},
        {value: 'deliverables', text: 'Produced Deliverables', sortable: true},
        {value: 'action', text: 'Actions', sortable: true}
      ],
      defaultSections: {
        imported: [],
        batchOne: [],
        batchTwo: [],
        approvalFinance: [],
        approvalLead: [],
        partiallyPaid: [],
        completed: []
      },
      archiveReportSections: {},
      filteredItems: [],
      selectedItems: [],
      items: [],
      filter: {
        search: ''
      },
      sectionIDs: campaignConfig.paymentConsSectionIDs
    }
  },
  computed: {
    ...mapState({
      archiveReports: state => state.campaign.archiveReports,
      updatedReport: state => state.campaign.updatedReport
    }),
    ...mapGetters('payment', [
      'getPaymentStatus',
      'formatPosts',
      'setBatchTableSections'
    ])
  },
  async mounted() {
    await this.getAllUsers()
    this.getArchiveLists()
  },
  methods: {
    selectAllItems($event) {
      if ($event.value && $event.items.length === 0) {
        return;
      }
      let batchIndex = null
      if ($event.items.length > 0) {
        batchIndex = this.filteredItems.findIndex(i => i.batchNo === $event.items[0].batchNo)
      }
      if (!$event.value) {
        this.filteredItems[batchIndex].selectedPayments = [];
        return;
      }
      this.filteredItems[batchIndex].selectedPayments = Object.assign([], $event.items);
    },
    restoreArchive(batchIndex) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = this.filteredItems[batchIndex].selectedPayments.map(item => {
            return Object.assign({}, {
              id: item.id,
              archive: false
            })
          })
          // Submit request to restore archived report data
          await this.$store.dispatch('campaign/updateReportsByIds', data)
          if (this.filteredItems[batchIndex].batchNo === this.sectionIDs.PAID) {
            await this.$store.dispatch('payment/updateCompletedPaymentsByReportID', {
              data
            })
          }
          this.isLoading = false;
          if (!this.updatedReport) {
            this.$swal({
              text: 'Error Archiving Reports.',
              type: 'error'
            });
            return
          }
          this.selectedItems = []
          // Show success message
          this.$swal({
            text: 'Successfully restored.',
            type: 'success'
          });
          this.getArchiveLists()
        }
      })
    },
    changeSearch(batchFilter, keyword) {
      batchFilter.workingSearch = keyword
    },
    close() {
      this.$emit('input');
    },
    searchGlobal() {
      this.filteredItems = this.items.map(item => {
        item.filter.workingSearch = this.searchText
        return item
      })
    },
    async getArchiveLists() {
      let payload = Object.assign({}, {
        filters: {
          archive: true
        }
      })
      await this.$store.dispatch('campaign/getPaymentConsolidateReport', payload)
      this.clearArchives()
      let formattedRets = this.formatPosts(this.archiveReports, this.archiveReportSections, this.Users, {})
      this.archiveReports = formattedRets.posts
      this.archiveReportSections = formattedRets.sections
      this.setBatchTableSections(this.items, this.headers, this.archiveReportSections)
      this.filteredItems = Object.assign([], this.items)
      this.isLoading = false
    },
    clearArchives() {
      this.items = []
      this.archiveReportSections = utils.func.refreshJSON(this.defaultSections)
    },
    async getAllUsers() {
      // Get all Users
      let response = await userAPIs.getAllUsersByRole(`${config.userRoles.SUPER_ADMIN_HIGH},${config.userRoles.SUPER_ADMIN_LOW},${config.userRoles.COMPANY_ADMIN_HIGH},${config.userRoles.COMPANY_ADMIN_LOW},${config.userRoles.AD_STRATEGIST},${config.userRoles.FINANCE},${config.userRoles.ACCOUNT_MANAGER}`)
      if (response) {
        this.Users = response.users
        this.Users = this.Users.map(u => {
          u.name = `${u.firstName}`
          return u
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ArchiveList.vue?401f8548